import * as React from "react";

import { useParams } from "react-router-dom";
import { withPageTracking } from "../../../services/postHog";
import QuizCreateNew from "./QuizCreateNew";
import { useEffect } from "react";
import GeneralLoading from "../../../shared-components/Loading";
import { Typography } from "@mui/material";
import { PublishedQuizGroup } from "../components/PublishedQuizGroup";
import { useQuizGroup } from "../hooks/useQuizGroup";

const QuizView = () => {
  const { quizGroupId } = useParams();

  const { quizGroup, setQuizGroup, loading, fetchQuizGroup } =
    useQuizGroup(quizGroupId);

  useEffect(() => {
    if (quizGroupId && !Object.keys(quizGroup).length) {
      fetchQuizGroup({ initialLoad: true });
    }
  }, [quizGroupId]);

  if (loading) {
    return <GeneralLoading />;
  }

  if (!Object.keys(quizGroup).length) {
    return <Typography>Unable to load quiz data</Typography>;
  }

  if (!quizGroup.isPublished) {
    return (
      <QuizCreateNew
        existingQuizGroup={quizGroup}
        onPageRefresh={fetchQuizGroup}
      />
    );
  }
  return (
    <PublishedQuizGroup quizGroup={quizGroup} setQuizGroup={setQuizGroup} />
  );
};

export default withPageTracking(QuizView, {
  feature: "quiz-view",
});
